<template>
  <div class="pa-4" style="position: relative;">
    
    <debt-wizard
      ref="debtWizardDialog"
      :household="household"
      @on-save="updateSavedDebt"
      use-url
    />

    <debt-sheet
      ref="debtSheet"
      :household="household"
      @on-save="updateSavedDebt"
      @on-plans-altered="$emit('on-plans-altered')"
    />

    <v-row class="justify-center">
      <v-col
        v-for="debt in debtsSorted"
        :key="'debt' + debt.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <debt-card 
          :debt="debt" 
          @on-delete="$emit('on-debt-deleted',debt)" 
          @on-click="$router.push({params:{debt_action:'edit',debt_id:debt.id}})"
        />
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="3">
        <debt-card 
          :debt="{}" 
          @on-click="$router.push({params:{debt_action:'add',debt_id:null}})"
          dense
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DebtCard from './Card'
import DebtWizard from './DebtWizard'
import DebtSheet from './DebtSheet'

export default {
  name: 'HouseholdsDebtsIndex',
  props: {
    household: {
      type: Object,
      required: true
    }
  },
  components: {
    DebtCard,
    DebtWizard,
    DebtSheet
  },
  data () {
    return {
    }
  },
  mounted() {
    
  },
  watch: {
    $route: {
      handler() {

      },
      deep: true
    }
  },
  computed: {
    debtsSorted() {
      let debts = JSON.parse(JSON.stringify(this.household.debts))
      debts.sort((a,b) => parseInt(b.balance) - parseInt(a.balance))
      return debts
    }
  },
  methods: {
    updateSavedDebt (debt) {
      this.$emit('on-debt-updated', debt)
    }
  }
}
</script>

<style lang="scss" scoped>
  .debtName {
    font-size: 16px;
  }
  .dragIcon {
    cursor: move;
  }
</style>
